import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AriaSortDirective } from './directives/aria-sort/aria-sort.directive';
import { AriaCheckedDirective } from './directives/aria-checked/aria-checked.directive';

@NgModule({
  imports: [CommonModule, AriaSortDirective, AriaCheckedDirective],
  exports: [AriaSortDirective, AriaCheckedDirective],
  providers: [],
})
export class AccessibilityModule {}
